import { useState } from 'react'
import { Button } from '@mui/material'
import filterStore from '../../stores/filterStore'

import logger from '../../utils/logger'

// shouldPersist - включает сохранение в localStorage
// persistKey - ключ для сохранения (чтобы разные страницы имели свои настройки)
function SaleTypeSelector({ saleTypeHandler, initialSelectedType = 'sale', shouldPersist = false, persistKey = 'saleType' }) {
	const [selectedType, setSelectedType] = useState(initialSelectedType) // Используем переданное начальное значение
	const [rentOptions, setRentOptions] = useState({
		longTerm: false,
		daily: false,
	})

	// Функция для безопасного сохранения в localStorage
	const saveToLocalStorage = (key, value) => {
		if (shouldPersist && key) {
			try {
				localStorage.setItem(key, value)
			} catch (error) {
				logger.log('Ошибка сохранения в localStorage:', error)
			}
		}
	}

	const handlerClick = type => {
		setSelectedType(type)
		saleTypeHandler(type)
		filterStore.setSaleType(type)
		
		// Сохраняем выбор в localStorage если включено
		saveToLocalStorage(persistKey, type)
		
		if (type !== 'rent') {
			// Сбрасываем опции аренды при выборе "sale" или "all"
			setRentOptions({ longTerm: false, daily: false })
		}
		
		// Сбрасываем extraFilter при изменении типа сделки
		filterStore.clearExtraFilter()
	}

	const handleRentOptionChange = option => {
		setRentOptions(prev => ({
			...prev,
			[option]: !prev[option],
		}))
		filterStore.setRentType(option)
	}

	function getMe() {
		logger.log(`selectedType:`, selectedType)
		logger.log(`rentOptions:`, rentOptions)
	}

	return (
		<div >
			
			{import.meta.env.VITE_SHOW_COMPONENT_NAME === 'true' && <div onClick={() => logger.log('SaleTypeSelector Render')}>% SaleTypeSelector 22 %</div>}

			<Button
				variant={selectedType === 'all' ? 'contained' : 'outlined'}
				sx={{ textTransform: 'none', mt: 1, mr: 1 }}
				onClick={() => handlerClick('all')}
			>
				Все
			</Button>

			<Button
				variant={selectedType === 'sale' ? 'contained' : 'outlined'}
				sx={{ textTransform: 'none', mt: 1, mr: 1 }}
				onClick={() => handlerClick('sale')}
			>
				Продажа
			</Button>
			<Button
				variant={selectedType === 'rent' ? 'contained' : 'outlined'}
				sx={{ textTransform: 'none', mt: 1, mr: 1 }}
				onClick={() => handlerClick('rent')}
			>
				Аренда
			</Button>
		</div>
	)
}

export default SaleTypeSelector
